export default {
  header: 'Proszę podać kilka szczegółów',
  placeholder: 'Dodaj komentarz...',
};
